import FlexHotGamesListPage from './pages/FlexHotGamesListPage'
import CreateFlexHotGamePage from './pages/CreateFlexHotGamePage'
import EditFlexHotGamePage from './pages/EditFlexHotGamePage'

export default [
	{
		path: '/operator/settings/flex-hot-games',
		element: <FlexHotGamesListPage />,
	},
	{
		path: '/operator/settings/flex-hot-games/create',
		element: <CreateFlexHotGamePage />,
	},
	{
		path: '/operator/settings/flex-hot-games/edit/:id',
		element: <EditFlexHotGamePage />,
	},
]
